export const spinnerDefaultStyle = theme => ({
  '&.MuiCircularProgress-root': {
    color: `${theme.tokens.ComponentSpinnerSpinnerCircularProgressColor}`,
    '& > .MuiCircularProgress-svg': {
      strokeLinecap: 'round',
      '& > .MuiCircularProgress-circle': {
        animationDuration: '1.8s',
        animationDelay: '1.5s',
        animationTimingFunction: 'linear'
      }
    }
  }
});